import React from "react";
import { EducationStyle } from "./style";
import { useNavigate } from "react-router-dom";
import DefaultButton from "../shared/DefaultButton";

export default function Education() {
    const navigation = useNavigate()

  return (
    <EducationStyle id="about">
        <DefaultButton onClick={() => {navigation('/')}} text={'Voltar'}/>  
      <div>
        <h4>Lavanderia e Tinturaria Valentin Negri - LTDA</h4>
        <p>
          - A empresa Tinturaria Valentim Negri Ltda que tem como razão social
          Tinturaria Valentim Negri Ltda foi fundada em 22/11/1978 e está
          cadastrada na Solutudo no segmento de Lavanderias com o CNPJ
          30.263.297/0001-49. No mercado, a empresa está localizada na Rua
          Araujo Leitao, Nº 48 - Loja B no bairro Engenho Novo em Rio de Janeiro
          - RJ, CEP 20715-310. A empresa Tinturaria Valentim Negri Ltda está
          cadastrada na Receita Federal sob o CNAE 9601-7/01 com atividade fim
          de Lavanderias.
        </p>
      </div>
    </EducationStyle>
  );
}
